import { createBrowserRouter } from 'react-router-dom';
import { protectedRoutes } from './protectedRoutes';
import { publicRoutes } from './publicRoutes';
import { RouteErrorBoundary } from './RouteErrorBoundary';

/**
 * Kept out of index.tsx so that file exports components only -- otherwise Fast
 * Refresh cannot hot-reload the route tree.
 *
 * One pathless parent so every route, public and protected, shares the error
 * screen -- above all for a page chunk that fails to download after a deploy.
 * It renders nothing of its own: a route with no element renders its matched child.
 */
export const router = createBrowserRouter([
  {
    ErrorBoundary: RouteErrorBoundary,
    children: [...publicRoutes, ...protectedRoutes],
  },
]);
